export const sampleLoan = {
  id: '5c5e0b2aa5bd3900133151bf',
  RTDocumentId: 557687594,
  adjustable: false,
  amount: 265000,
  amountForMerge: 165000,
  archiveUuid: 'a21cf6a7-35ac-4b81-90ca-5dfe4cee8ee2',
  created: '2019-02-08T23:05:14.000Z',
  date: '2015-09-01',
  documentType: 'Warranty Deed',
  homeId: '585d76f13f59ed00049abe72',
  lender: 'PRIVATE INDIVIDUAL',
  loanType: 'FIRST CEL',
  rate: 4.625,
  refi: false,
  source: 'user',
  status: 'current',
  termYearsEstimated: 30,
  termYears: 30,
  payment: {
    total: 1362.47,
    principal: 397.85691978098555,
    interest: 964.6130802190145
  },
  facts: {
    monthlyPayment: 1362.47,
    totalInterest: 225488.98040903936
  },
  progress: {
    interestLeft: 184747.57894767064,
    interestPaid: 40741.40146136872,
    interestDiff: 0,
    paymentsLeft: 319,
    paymentsMade: 41,
    principalLeft: 249880.13146136873,
    principalPaid: 15119.868538631285,
    principalDiff: 0
  },
  maturityDate: {
    nochange: {
      date: '2045-09-01',
      interestPid: 225488.98040903936,
      monthsLeft: 319
    }
  },
  stats: {
    interestSavings: {
      nochange: 0
    },
    totalCost: {
      nochange: 490488.98040903936
    }
  },
  cashout: {
    amount: null,
    ownershipPercent: null,
    percent: null,
    retainPercent: 20
  }
}
